import React from "react";
import { Route } from "react-router-dom";

import OrganizationEdit from "../components/settings/organizationEdit";
import Profile from "./Profile";
import {DebugElement} from "../Atollon/debug";

const Settings = props => {
  const { match } = props;
  
  return (
    <div className="flex-col">
        <DebugElement text={"src/containers/Settings.js"}/>
      <Route path={`${match.path}/profile`} component={Profile} {...props} />
      <Route
        path={`${match.path}/organization/:id`}
        component={OrganizationEdit}
        {...props}
      />
    </div>
  );
};

export default Settings;



// WEBPACK FOOTER //
// ./src/pages/Settings.js